import { useEffect } from "react";
import { getSocket } from "../lib/socket";

export function useSocketEvent<T = unknown>(event: string, handler: (data: T) => void) {
  useEffect(() => {
    const s = getSocket();
    s.on(event, handler);
    return () => {
      s.off(event, handler);
    };
  }, [event, handler]);
}

export function joinTenant(tenantId: string | null) {
  if (!tenantId) return;
  const s = getSocket();
  s.emit("join_tenant", tenantId);
}
